
import "../AuthMobile.less";
import { FormattedMessage } from "react-intl";

const RegisterMobileDisclaimer = () => {
    return (
        <>
            <div className="m-register-tnc">
                <FormattedMessage id='AUTH_REGISTER_TNC' values={{
                    0: <span className="m-tnc-bold"><FormattedMessage id='AUTH_REGISTER_TNC_BTN_TXT' /></span>
                }} />
            </div>
        </>
    );
};

export default RegisterMobileDisclaimer;
